import { render, staticRenderFns } from "./user_top_info.vue?vue&type=template&id=cc224b74&scoped=true"
import script from "./user_top_info.vue?vue&type=script&lang=js"
export * from "./user_top_info.vue?vue&type=script&lang=js"
import style0 from "./user_top_info.vue?vue&type=style&index=0&id=cc224b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc224b74",
  null
  
)

export default component.exports